import "./style.scss";
import { VerificationBtn } from "../components/button";
import { PATH_LIST } from "shared/lib/react-router";
import FormField from "shared/ui/form-field";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { accountStore } from "entities/account";
import { useSchema } from "helpers/functions";
import { useStore } from "zustand";
import { useState } from "react";
import { sircapApi } from "shared/api/sircap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ValidationSchema = (y: any) =>
  Yup.object().shape({
    street: Yup.string(), // .required(y("streetRequired")),
    building: Yup.string(), // .required(y("buildingNumberRequired")),
    apartment: Yup.string(), // .required(y("apartmentNumberRequired")),
    city: Yup.string(), // .required(y("cityRequired")),
  });

export const ResidenceAddressPage = () => {
  const { t: err } = useTranslation("errors");
  const { t } = useTranslation("onboarding-auth");
  const { t: o } = useTranslation("onboarding");
  const schema = useSchema(ValidationSchema);

  const { kyc } = useStore(accountStore);
  const [isSubmit, setIsSubmit] = useState(false);
  const { synckyc } = useStore(accountStore);
  const navigate = useNavigate();

  const onSubmit = async (values: any) => {
    setIsSubmit(true);
    const resp = await sircapApi.account.infoKyc({
      address: {
        city: values.city,
        street: values.street,
        building: values.building,
        apartment: values.apartment,
        zip_code: values.zip_code,
      },
    });
    if (resp.error) {
      toast.error(err(String(resp.error.code)));
    } else {
      const { kyc, user } = resp.data.data;
      synckyc(kyc);

      navigate(PATH_LIST.uploadCredentials);
    }
    setIsSubmit(false);
  };

  return (
    <div className="verification-residence-address">
      <p>{o("residenceAddress")}</p>
      <Formik
        initialValues={{
          street: kyc?.address_json?.street || "",
          building: kyc?.address_json?.building || "",
          city: kyc?.address_json?.city || "",
          zip_code: kyc?.address_json?.zip_code || "",
          apartment: kyc?.address_json?.apartment || "",
        }}
        validationSchema={schema}
        onSubmit={(values) => onSubmit(values)}
      >
        {({ values, isValid }) => (
          <Form>
            <FormField
              autoFocus
              customClass="registration-field"
              type="text"
              id="city"
              label={o("city")}
              placeholder={o("city")}
            />
            <FormField
              customClass="registration-field"
              type="text"
              id="street"
              label={o("street")}
              placeholder={o("street")}
            />
            <div className="building-apartment-wrapper">
              <FormField
                customClass="registration-field"
                type="text"
                id="building"
                label={o("buildingNumber")}
                placeholder={o("buildingNumber")}
              />
              <FormField
                customClass="registration-field"
                type="text"
                id="apartment"
                label={o("apartmentNumber")}
                placeholder={o("apartmentNumber")}
              />
            </div>
            <VerificationBtn
              type="submit"
              disabled={
                !isValid ||
                isSubmit ||
                Object.values(values).every((v) => !v.trim())
              }
              text={t("continue")}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};
